/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./../lib/httpClient.ts";
import {
  ExportProjectsRequestDTO,
  PageResponse,
  Response,
} from "././index.d.ts";

export class Projects<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description list project with request body
   *
   * @tags projects
   * @name ListProject
   * @request GET:/projects
   * @secure
   */
  listProject = (
    query: {
      /**
       * Current page number
       * @format int32
       */
      number: number;
      /**
       * the page size
       * @format int32
       */
      size: number;
      /** the fields to return, eg: ["name","description","createdAt"] */
      fields: string;
      /** the search keyword */
      keyword?: string;
      /** the logic operator, eg: and, or */
      logicOperator?: string;
      /** the search filters, eg: [{"field":"name","operator":"contains","value":"demo"},{"field":"description","operator":"contains","value":"demo"}] */
      filters?: string;
      /** the sort orders, eg: [{"field":"createdAt","sort":"desc"},{"field":"updatedAt","sort":"asc"}] */
      sort?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<PageResponse, PageResponse | Response>({
      path: `/projects`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description save project with request body
   *
   * @tags projects
   * @name SaveProject
   * @request POST:/projects
   * @secure
   */
  saveProject = (data: Record<string, object>, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/projects`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Get project details by ID
   *
   * @tags projects
   * @name GetProject
   * @request GET:/projects/{id}
   * @secure
   */
  getProject = (id: string, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/projects/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Approve Artifacts and Complete Projects
   *
   * @tags projects
   * @name CompleteProjects
   * @request POST:/projects/{id}
   * @secure
   */
  completeProjects = (
    id: string,
    data: Record<string, object>,
    params: RequestParams = {},
  ) =>
    this.http.request<Response, Response>({
      path: `/projects/${id}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Delete a project by ID
   *
   * @tags projects
   * @name DeleteArtworkProject
   * @request DELETE:/projects/{id}
   * @secure
   */
  deleteArtworkProject = (id: string, params: RequestParams = {}) =>
    this.http.request<Response, Response>({
      path: `/projects/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Export projects data as a file stream
   *
   * @tags projects
   * @name ExportProjects
   * @request POST:/projects/export
   * @secure
   */
  exportProjects = (
    data: ExportProjectsRequestDTO,
    params: RequestParams = {},
  ) =>
    this.http.request<File, File | Response>({
      path: `/projects/export`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
